import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("img", {
        staticStyle: { position: "fixed", top: "0", left: "0", "z-index": "2" },
        attrs: { src: require("../../assets/Inca_logo_PNG.png"), width: "350" },
      }),
      _c("img", {
        staticStyle: {
          position: "absolute",
          "z-index": "1",
          top: "0",
          right: "0",
          height: "100%",
          opacity: "0.5",
        },
        attrs: {
          src: require("../../assets/Nuevo_Inca_fondo_opacidad.png"),
          alt: "",
        },
      }),
      _c("div", { staticClass: "top-login" }),
      _c("div", { staticClass: "bottom-login" }),
      _c(
        VCard,
        {
          staticClass: "text-center pa-1",
          staticStyle: { "z-index": "3", "border-radius": "40px !important" },
          attrs: { elevation: "10" },
        },
        [
          _c(
            VCardText,
            { staticStyle: { padding: "50px" } },
            [
              _c(
                VForm,
                {
                  ref: "form",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function ($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid",
                  },
                },
                [
                  _c("div", [
                    _c(
                      "i",
                      {
                        staticClass: "material-icons mb-8 mr-0",
                        staticStyle: { "font-size": "200px" },
                      },
                      [_vm._v("account_circle")]
                    ),
                  ]),
                  _c("div", [
                    _c("span", [
                      _vm._v(
                        "La opción de inicio de sesión puede variar según tu empresa."
                      ),
                    ]),
                  ]),
                  _vm.current_provider === "email"
                    ? _c(
                        "div",
                        [
                          _c(VRow, [
                            _c(
                              "div",
                              { staticClass: "col-12" },
                              [
                                _c(VTextField, {
                                  attrs: {
                                    name: "email",
                                    label: "Correo",
                                    id: "email",
                                    small: "",
                                    dense: "",
                                    outlined: "",
                                  },
                                  model: {
                                    value: _vm.email,
                                    callback: function ($$v) {
                                      _vm.email = $$v
                                    },
                                    expression: "email",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col-12" },
                              [
                                _c(VTextField, {
                                  attrs: {
                                    name: "password",
                                    label: "Contraseña",
                                    id: "password",
                                    type: "password",
                                    small: "",
                                    dense: "",
                                    outlined: "",
                                  },
                                  model: {
                                    value: _vm.password,
                                    callback: function ($$v) {
                                      _vm.password = $$v
                                    },
                                    expression: "password",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c(
                            VBtn,
                            {
                              staticClass: "mt-5 mb-5",
                              staticStyle: {
                                "border-radius": "20px !important",
                              },
                              attrs: {
                                color: "primary",
                                block: "",
                                "x-large": "",
                              },
                              on: { click: _vm.onLogin },
                            },
                            [_vm._v("Ingresar")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    [
                      _c(VRow, [
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c(VSelect, {
                              attrs: {
                                items: _vm.companies,
                                "item-text": "text",
                                "item-value": "id",
                                label: "Compañia",
                                small: "",
                                dense: "",
                                outlined: "",
                              },
                              model: {
                                value: _vm.current_company,
                                callback: function ($$v) {
                                  _vm.current_company = $$v
                                },
                                expression: "current_company",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VBtn,
                    {
                      staticClass: "mb-2",
                      staticStyle: { "border-radius": "20px !important" },
                      attrs: {
                        disabled: _vm.isSignInDisabled,
                        color: "primary",
                        block: "",
                        "x-large": "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onLogin("google")
                        },
                      },
                    },
                    [
                      _c(VIcon, { attrs: { small: "", left: "" } }, [
                        _vm._v("mdi-" + _vm._s("google")),
                      ]),
                      _vm._v(" " + _vm._s("Ingresar con Google") + " "),
                    ],
                    1
                  ),
                  _vm.current_company == "casa-andina"
                    ? _c(
                        VBtn,
                        {
                          staticClass: "mb-2",
                          staticStyle: { "border-radius": "20px !important" },
                          attrs: {
                            disabled: _vm.isSignInDisabled,
                            color: "primary",
                            block: "",
                            "x-large": "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onLogin("microsoft")
                            },
                          },
                        },
                        [
                          _c(VIcon, { attrs: { small: "", left: "" } }, [
                            _vm._v("mdi-" + _vm._s("microsoft")),
                          ]),
                          _vm._v(" " + _vm._s("Ingresar con Microsoft") + " "),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.current_company == "smi"
                    ? _c(
                        VBtn,
                        {
                          staticClass: "mb-2",
                          staticStyle: { "border-radius": "20px !important" },
                          attrs: {
                            disabled: _vm.isSignInDisabled,
                            color: "primary",
                            block: "",
                            "x-large": "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onLogin("microsoft")
                            },
                          },
                        },
                        [
                          _c(VIcon, { attrs: { small: "", left: "" } }, [
                            _vm._v("mdi-" + _vm._s("microsoft")),
                          ]),
                          _vm._v(" " + _vm._s("Ingresar con Microsoft") + " "),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.current_company == "intercorp-dev"
                    ? _c(
                        VBtn,
                        {
                          staticClass: "mb-2",
                          staticStyle: { "border-radius": "20px !important" },
                          attrs: {
                            disabled: _vm.isSignInDisabled,
                            color: "primary",
                            block: "",
                            "x-large": "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onLogin("saml.azure-ad-saml")
                            },
                          },
                        },
                        [
                          _c(VIcon, { attrs: { small: "", left: "" } }, [
                            _vm._v("mdi-" + _vm._s("microsoft")),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(
                                "Ingresar con Office 365 - Pruebas Data Office"
                              ) +
                              " "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.current_company == "interbank"
                    ? _c(
                        VBtn,
                        {
                          staticClass: "mb-2",
                          staticStyle: { "border-radius": "20px !important" },
                          attrs: {
                            disabled: _vm.isSignInDisabled,
                            color: "primary",
                            block: "",
                            "x-large": "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onLogin("saml.azure-ad-ibk")
                            },
                          },
                        },
                        [
                          _c(VIcon, { attrs: { small: "", left: "" } }, [
                            _vm._v("mdi-" + _vm._s("microsoft")),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s("Ingresar con Microsoft - Interbank") +
                              " "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.current_company == "intercorp"
                    ? _c(
                        VBtn,
                        {
                          staticClass: "mb-2",
                          staticStyle: { "border-radius": "20px !important" },
                          attrs: {
                            disabled: _vm.isSignInDisabled,
                            color: "primary",
                            block: "",
                            "x-large": "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onLogin("saml.azure-ad-ibk")
                            },
                          },
                        },
                        [
                          _c(VIcon, { attrs: { small: "", left: "" } }, [
                            _vm._v("mdi-" + _vm._s("microsoft")),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s("Ingresar con Microsoft - Intercorp") +
                              " "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.current_company == "foh"
                    ? _c(
                        VBtn,
                        {
                          staticClass: "mb-2",
                          staticStyle: { "border-radius": "20px !important" },
                          attrs: {
                            disabled: _vm.isSignInDisabled,
                            color: "primary",
                            block: "",
                            "x-large": "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onLogin("saml.azure-ad-foh")
                            },
                          },
                        },
                        [
                          _c(VIcon, { attrs: { small: "", left: "" } }, [
                            _vm._v("mdi-" + _vm._s("microsoft")),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s("Ingresar con Microsoft - Financiera Oh") +
                              " "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    VBtn,
                    {
                      staticClass: "mb-1",
                      attrs: { text: "", small: "", block: "" },
                      on: {
                        click: function ($event) {
                          _vm.showEmailLink = !_vm.showEmailLink
                        },
                      },
                    },
                    [
                      _c(VIcon, { attrs: { small: "", left: "" } }, [
                        _vm._v("mdi-email-outline"),
                      ]),
                      _vm._v(
                        " " + _vm._s("Ingresar con enlace al correo") + " "
                      ),
                    ],
                    1
                  ),
                  _vm.showEmailLink
                    ? _c(
                        "div",
                        [
                          !_vm.emailLinkSent
                            ? [
                                _c(VTextField, {
                                  staticClass: "mb-2",
                                  attrs: {
                                    label: "Correo corporativo",
                                    name: "emailLink",
                                    small: "",
                                    dense: "",
                                    outlined: "",
                                    "hide-details": "auto",
                                  },
                                  on: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.sendEmailLink($event)
                                    },
                                  },
                                  model: {
                                    value: _vm.emailLink,
                                    callback: function ($$v) {
                                      _vm.emailLink = $$v
                                    },
                                    expression: "emailLink",
                                  },
                                }),
                                _c(
                                  VBtn,
                                  {
                                    staticStyle: {
                                      "border-radius": "20px !important",
                                    },
                                    attrs: {
                                      color: "primary",
                                      block: "",
                                      loading: _vm.sendingLink,
                                    },
                                    on: { click: _vm.sendEmailLink },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s("Enviarme enlace de acceso") +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            : _c(
                                VAlert,
                                {
                                  staticClass: "mt-2",
                                  staticStyle: { "text-align": "left" },
                                  attrs: {
                                    type: "success",
                                    text: "",
                                    dense: "",
                                  },
                                },
                                [
                                  _vm._v(" Enviamos un enlace de acceso a "),
                                  _c("b", [_vm._v(_vm._s(_vm.emailLink))]),
                                  _vm._v(
                                    ". Revisa tu bandeja (y la carpeta de spam) y ábrelo en este mismo navegador. El enlace es de un solo uso y expira pronto. "
                                  ),
                                ]
                              ),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }